import React from 'react'
import ReactDOM from 'react-dom/client'
import './asserts/css/index.css'
import './asserts/css/custom.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ConfigProvider, theme } from 'antd'
import { installGlobalErrorPopupHandling } from './utils/errorPopup'

installGlobalErrorPopupHandling()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#37762f',
          colorInfo: '#37762f',
          colorSuccess: '#37762f',
          colorLink: '#37762f',
          colorLinkHover: '#2f6829',
          colorTextBase: '#1f2937',
          colorTextSecondary: '#6b7280',
          colorBorder: '#dbe3db',
          borderRadius: 10,
          wireframe: false,
          fontFamily: "'Avenir', Inter, Roboto, Segoe UI, Arial, sans-serif",
          fontSize: 14
        },
        components: {
          Button: {
            borderRadius: 10,
            controlHeight: 40,
            colorPrimary: '#37762f',
            colorPrimaryHover: '#2f6829',
            colorPrimaryActive: '#2a5f24'
          },
          Input: {
            borderRadius: 10,
            controlHeight: 40
          },
          Select: {
            borderRadius: 10,
            controlHeight: 40
          },
          Card: {
            borderRadiusLG: 12
          }
        },
        algorithm: theme.defaultAlgorithm
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
